import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import {
  LicenseTypes,
  Operation,
  PageFor,
} from "../../../../../utils/Enum.types";
import Add from "./Add";
import List from "./List";
import { IObjectKeys } from "../../../../../utils/formTypes";
import { Form, Formik, FormikProps } from "formik";
import { categoryValidation } from "../../../../../utils/validationSchema";
import { AddStockCategory, UpdateStockCategory } from "./queries/mutations";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AddStockCategoryResult,
  AddStockCategoryVar,
  AtsStckCategory,
  AtsStckCategoryOrderField,
  UpdateStockCategoryResult,
  UpdateStockCategoryVar,
} from "./queries/types";
import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import useUrlParams from "../../../../../customHooks/useUrlParams";

import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import { GetCategoryNodeById, GetStockCategories } from "./queries/queries";
import { nodeVar, OrderDirection } from "../../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../../context/context";
import MessageModal from "../../../../../customComponents/MessageModal";
import { msgType } from "../../../../../utils/types";
import { MasterDataProps } from "../itemgroup/Index";
import Close from "../../../../../images/Close.svg";
import LoadingModal from "../../../../pages/LoadingModal";
import Navbar from "../../../../common/layout/Navbar";
interface formDataType extends IObjectKeys {
  groupName: string;
  noOfDecimals: number;
}

export interface CommonProps extends MasterDataProps {
  setOperation: React.Dispatch<React.SetStateAction<Operation>>;
  handleClear?: any;
}
export interface AddMasterDataProps extends CommonProps {
  formData: formDataType;
  handleValueChange: (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<formDataType>
  ) => void;
  meta: FormikProps<formDataType>;
  operation: Operation;
}

export interface ListPageProps extends CommonProps {
  setMessage: React.Dispatch<React.SetStateAction<msgType>>;
}

const Category = ({ type, setModal }: MasterDataProps) => {
  const navigate = useNavigate();
  const [message, setMessage] = useState(emptyMessage);

  const { user_details } = useLoggedInUserDetails();

  const { state } = useContext(AppContext);

  const [operation, setOperation] = useState(Operation.CREATE);
  const { customer_id } = useUrlParams();
  const [formData, setFormData] = useState<formDataType>({
    groupName: "",
    noOfDecimals: 0,
  });

  const [GetCatByNodeId, { loading: GetCatByNodeIdLoading }] = useLazyQuery<
    { node: AtsStckCategory },
    nodeVar
  >(GetCategoryNodeById);

  const [AddCategoryDetails, { loading: AddStockCategoryLoading }] =
    useMutation<AddStockCategoryResult, AddStockCategoryVar>(AddStockCategory, {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    });
  const [UpdateCategoryDetails, { loading: UpdateStockCategoryLoading }] =
    useMutation<UpdateStockCategoryResult, UpdateStockCategoryVar>(
      UpdateStockCategory,
      {
        onError: (e) => {
          setMessage({
            flag: true,
            message: e.message,
            operation: Operation.NONE,
          });
        },
      }
    );

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<formDataType>
  ) => {
    const { name, value } = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };
  const handleClear = () => {
    const inputElement = document.getElementsByName(
      "groupName"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();
    setFormData({
      groupName: "",
      noOfDecimals: 0,
    });
  };

  const handleSubmit = async () => {
    if (customer_id) {
      if (operation === Operation.CREATE) {
        const empAdded = AddCategoryDetails({
          variables: {
            user_details,
            customer_id,
            category_name: formData.groupName,
          },
          refetchQueries: [
            {
              query: GetStockCategories,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsStckCategoryOrderField.CATEGORY_NAME,
                },

                name: EMPTY_STRING,
              },
            },
          ],
        });
        const { data } = await empAdded;

        if (data && data.AddStockCategory) {
          setMessage({
            flag: true,
            message: "Category added successfully",
            operation: Operation.CREATE,
          });
        }
      } else {
        const customerUpdated = UpdateCategoryDetails({
          variables: {
            user_details,
            category_id: state.categoryId,
            category_name: formData.groupName,
          },
          refetchQueries: [
            {
              query: GetStockCategories,
              variables: {
                after: null,
                customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsStckCategoryOrderField.CATEGORY_NAME,
                },

                name: EMPTY_STRING,
              },
            },
          ],
        });
        const { data } = await customerUpdated;

        if (data && data.UpdateStockCategory) {
          setMessage({
            flag: true,
            message: "Category details updated successfully",
            operation: Operation.CREATE,
          });
        }
      }
    }
  };

  const hanldeClear = () => {
    setFormData({
      groupName: "",
      noOfDecimals: 0,
    });
  };
  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      hanldeClear();
      setOperation(Operation.CREATE);
    }
    setMessage(emptyMessage);
  };

  useEffect(() => {
    if (state.categoryId && operation === Operation.UPDATE) {
      GetCatByNodeId({
        variables: {
          id: state.categoryId,
      
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setFormData({
            groupName: data.node.categoryName,
            noOfDecimals: 0,
          });
        }
      });
    }
  }, [state.categoryId, GetCatByNodeId, operation]);

  return (
    <>
      {type === PageFor.GENERAL && (
        <Navbar NavType={LicenseTypes.CUSTOMER_USERS} />
      )}
      <div className="master-data--modal--title">
        <Title>Category</Title>
        {type === PageFor.MODAL && (
          <img src={Close} alt="" onClick={() => setModal?.(false)} />
        )}
      </div>

      <Formik
        initialValues={formData}
        validationSchema={categoryValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form
              className={`master-data${
                type === PageFor.MODAL ? "--modal" : ""
              }`}
            >
              <div
                className={`master-data__datablock${
                  type === PageFor.MODAL ? "--modal" : ""
                }`}
              >
                <div className="master-data__datablock--left">
                  <Add
                    type={PageFor.GENERAL}
                    formData={formData}
                    handleValueChange={handleValueChange}
                    setOperation={setOperation}
                    meta={meta}
                    operation={operation}
                  />
                </div>
                <div className="master-data__datablock--right">
                  <List
                    type={PageFor.GENERAL}
                    setOperation={setOperation}
                    setMessage={setMessage}
                  />
                </div>
              </div>
              <Button mode="save" className="submit" type="submit" />
              <Button mode="clear" type="button" onClick={handleClear} />
              {type === PageFor.GENERAL ? (
                <Button
                  mode="back"
                  type="button"
                  onClick={() => navigate(-1)}
                />
              ) : (
                <Button
                  mode="cancel"
                  type="button"
                  onClick={() => setModal?.(false)}
                />
              )}
            </Form>
          );
        }}
      </Formik>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal
        flag={
          GetCatByNodeIdLoading ||
          AddStockCategoryLoading ||
          UpdateStockCategoryLoading
        }
      />
    </>
  );
};

export default Category;
